import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { WebShopType } from '../Enums/WebShopType.enum';

export class WebShopDefinition<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: url */
  url?: string;
  /** Alias: userName */
  userName?: string;
  /** Alias: customerNumber */
  customerNumber?: string;
  /** Alias: password */
  password?: string;
  /** Alias: sDObjMembercode */
  sDObjMembercode?: number;
  /** Alias: shopType */
  shopType?: WebShopType;

  __typename?: string;
}

const fields: FieldDefinitions<WebShopDefinition> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  url: {
    alias: 'url',
  },
  userName: {
    alias: 'userName',
  },
  customerNumber: {
    alias: 'customerNumber',
  },
  password: {
    alias: 'password',
  },
  sDObjMembercode: {
    alias: 'sDObjMembercode',
  },
  shopType: {
    alias: 'shopType',
  },
  __typename: {
    alias: '__typename',
  },
};

export const webShopDefinitionEntityDefinition: EntitiyDefinition<WebShopDefinition> =
  {
    local: {},
    remote: {
      queryName: 'getWebShopDefinitions',
      fragmentName: 'WebShopDefinition',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertWebShopDefintion',
          args: [
            { name: 'input', type: 'InputWebShopDefinition!' },
            { name: 'drySave', type: 'Boolean' },
          ],
        },
      },
      params: [{ name: 'ids', type: '[ID]' }],
    },
    fieldDefinitions: fields,
  };
